import BrandWordmark from '../components/BrandWordmark';
import React, { useContext, useEffect, useState } from 'react'
import { Button, Layout, } from 'antd';
import GlobalStateContext from '../context';
import { SET_ITEM } from '../store/actions/types';
import { Link, withRouter } from 'react-router-dom';
import ClientAppearance, { ClientSurface } from '../components/ClientAppearance';
import Sidebar from '../components/protected/Sidebar';
import { Animated } from 'react-animated-css';
import StreamWebService from '../classes/StreamWebService';
import MobileMenu from '../components/MobileMenu';

function ProtectedPagesLayout({ children }) {
  const [state, dispatch] = useContext(GlobalStateContext);
  const { collapsed_nav, hide_nav } = state;
  
  const [compact, setCompact] = useState(window.innerWidth < 1024);
  useEffect(() => {
    const query = window.matchMedia('(max-width: 1023px)');
    const update = () => setCompact(query.matches);
    query.addListener(update);
    return () => query.removeListener(update);
  }, []);

  // Calculate margin based on sidebar state
  const layoutStyle = {
    marginLeft: (hide_nav || compact) ? "0px" : collapsed_nav ? '80px' : '256px',
    transition: 'margin-left 0.2s ease-in-out'
  }
  

  const fetchUserStreams = async () => {
    const webservice = new StreamWebService()
    await webservice.getStreams().then(res => res.data)
      .then(values => dispatch({
        type: SET_ITEM,
        payload: ['streams', values.entries]
      }));
  }
  
  useEffect(() => {
    fetchUserStreams();
  }, [])

  return (
    <Layout className="client-workspace" style={{ minHeight: '100vh' }}>
      <ClientSurface />
      {!compact && (
        <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={!hide_nav}>
          <Sidebar />
        </Animated>
      )}

      <Layout style={layoutStyle}>
        <div className="min-h-screen bg-gray-50">
          <div className="client-topbar">{(compact || hide_nav) && <Link to="/app" className="client-wordmark"><BrandWordmark/></Link>}<div className="client-topbar-tools"><ClientAppearance /><Link className="client-account-link" to="/app/account">Account</Link></div></div>
          

          
          <div className="flex-1">
            <div className={`${compact ? 'mb-5' : ''}`}>
              {children}
            </div>
          </div>
        </div>
      </Layout>
      
      {(hide_nav && !compact) && (
        <Button
          shape="circle" 
          size="large" 
          style={{ 
            position: "fixed", 
            top: "50%", 
            left: "10px",
            zIndex: 1001,
            transform: 'translateY(-50%)'
          }} 
          icon="menu-unfold"
          onClick={() => dispatch({
            type: SET_ITEM,
            payload: ['hide_nav', !hide_nav]
          })}
        />
      )}
      
      {compact && <MobileMenu/>}
    </Layout>
  )
}

export default withRouter(ProtectedPagesLayout);